// extracted by mini-css-extract-plugin
module.exports = {"container":"_2MZH8gmAkY3yQ9ICzCKqJn","groupsList":"mdnp4GIAT3FjjdQUH9_hw"};